import has from '@dojo/framework/core/has';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
import { Button } from '@dojo/widgets/button';
import { Icon } from '@holmescorp/base-widgets';
import { convertToBoolean } from '@holmescorp/common/convertToBoolean';
import { createNlsMiddleware } from '@holmescorp/lcc-state';
import { publish } from '@holmescorp/pub-sub';
import css from '../../css/pretest.m.css';
import { Card } from '../../widgets/index';
const icache = createICacheMiddleware();
const nls = createNlsMiddleware('ditabook');
const quizNls = createNlsMiddleware('quiz');
const factory = create({
    icache,
    theme,
    nls,
    quizNls
}).properties();
export const PretestCard = factory(({ id, properties, middleware: { theme, nls, quizNls } }) => {
    const { quizId, domain, status, xqa } = properties();
    const themeCss = theme.classes(css);
    const { messages: { assessment_titles = '(ditabook) assessment_quizzes', is_demo = 'false' } } = nls();
    const { messages: { begin = '{quiz} begin', continue: kontinue = '{quiz} continuue' } } = quizNls();
    const titles = JSON.parse(assessment_titles);
    const cardTitle = titles[domain];
    const domainTitle = domain.charAt(0).toUpperCase() + domain.slice(1);
    const actionLabel = status.active ? kontinue : begin;
    const extension = has('use-svg-card-header-images') || has('use-svg-header-image') ? 'svg' : 'png';
    const isDemo = convertToBoolean(is_demo);
    const widgetId = `card-${id}`;
    const key = `${domain}-card`;
    return v('div', { id, widgetId, key, xqa: xqa || key, tabIndex: 0, classes: [theme.variant(), themeCss.root] }, [
        w(Card, {
            xqa: `card-${domain}`,
            mediaSrc: `${window.hcstatic.portal_cdn}/js/images/${window.hcstatic.portal_site}/card_header_${domain}_pretest.${extension}`,
            mediaTitle: cardTitle
        }, [
            {
                content: v('div', {}, [
                    v('div', { classes: [themeCss.title, 'card_title'], innerHTML: cardTitle }),
                    v('div', { classes: [themeCss.actions] }, [
                        status.complete
                            ? w(Icon, { faname: 'circle-check', size: '2x' })
                            : w(Button, {
                                onClick: () => {
                                    publish('site/assessment', quizId);
                                },
                                disabled: isDemo,
                                aria: { label: `${actionLabel} ${domainTitle} Pre-test` },
                                iconPosition: 'after'
                            }, [
                                {
                                    icon: isDemo
                                        ? v('span', { styles: { paddingLeft: '5px' } }, [
                                            w(Icon, { faname: 'lock' })
                                        ])
                                        : undefined,
                                    label: actionLabel
                                }
                            ])
                    ])
                ])
            }
        ])
    ]);
});
export default PretestCard;
